import React, { useCallback, useContext } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import SkydevLogo from "../../assets/images/obc-logo.png";
import userIcon from "../../assets/images/user-icon.png";
import "./Login.less";
import { AuthContext } from "context/AuthContext";
import { useTranslation } from "react-i18next";

const Login = ({ ...props }) => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const { login, loading } = useContext(AuthContext);

  const onFinish = useCallback(
    async (values) => {
      login(values).then(() => {
        navigate("/cart-private");
      });
    },
    [login, navigate],
  );

  return (
    <div className="login container-fix bg-img-login">
      <div className="body-container">
        <div className="animate__animated animate__fadeIn" id={"loginPage"}>
          <div className="container">
            <Link to="/">
              <img className="logo_img" src={SkydevLogo} alt="Skydev" />
            </Link>

            <Row className="login_body" gutter={[16, 16]}>
              <Col className="project" xs={24} md={12}>
                <div className="login-text">
                  <h2>{t("login.event-title")}</h2>
                </div>
              </Col>
              <Col className="login-form" xs={24} md={12}>
                <div className={"title"}>
                  <img src={userIcon} alt="GotecLand" />
                  <p>{t("login.form-title")}</p>
                </div>
                <Form
                  form={form}
                  name="horizontal_login"
                  layout="inline"
                  onFinish={onFinish}
                >
                  <Form.Item
                    name="userNameOrEmailAddress"
                    rules={[
                      { required: true, message: t("login.email-required") },
                    ]}
                    className="form-group"
                  >
                    <Input
                      className="form-control"
                      placeholder={t("login.email-placeholder")}
                      autoComplete="off"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      { required: true, message: t("login.password-required") },
                    ]}
                    className="form-group"
                  >
                    <Input
                      type="password"
                      placeholder={t("login.password-placeholder")}
                      className="form-control"
                      autoComplete="off"
                    />
                  </Form.Item>
                  <Form.Item shouldUpdate className="text-center">
                    {() => (
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={
                          !form.isFieldsTouched(true) ||
                          !!form
                            .getFieldsError()
                            .filter(({ errors }) => errors.length).length
                        }
                        className="btn btn-primary"
                        loading={loading}
                      >
                        {t("login.submit")}
                      </Button>
                    )}
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
